// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

import FileUploader from './file_uploader';

frappe.provide('frappe.ui');
frappe.ui.FileUploader = FileUploader;
